import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import './index.css'

// Import monitoring configs
import { initSentry } from './configs/sentry.config'
import { initMarker } from './configs/marker.config'
import { AnalyticsProvider } from './components/layout/analytics-provider'
import { createQueryClient } from './configs/query-client.config'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Initialize monitoring tools
initSentry()
initMarker()

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Create a client
const queryClient = createQueryClient()

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const clerkAllowedRedirectOrigins =
  import.meta.env.VITE_CLERK_ALLOWED_REDIRECT_ORIGINS?.split(',')
    .map((origin) => origin.trim())
    .filter(Boolean)

if (!clerkPubKey) {
  throw new Error('Missing Clerk Publishable Key')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={clerkPubKey}
      allowedRedirectOrigins={
        clerkAllowedRedirectOrigins?.length
          ? clerkAllowedRedirectOrigins
          : undefined
      }
    >
      <AnalyticsProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AnalyticsProvider>
    </ClerkProvider>
  </StrictMode>
)
